module.exports = __webpack_public_path__ + "img/apple_with_bite_in_it.4eb30f16.jpg";